import BaseCtrl from 'edge/platform/base/BaseCtrl';

/*
 The information being collected on this page is covered by PCI-DSS.
 It is the customer's responsibility to ensure that any security/data protection measures that are required are implemented.
 Data from this page should only ever be transmitted over HTTPS.
 */
var fn = function fn($scope, StateUtils, RootStates, $state, CoveragesUtil, CoverageService, submissionViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var POLICY_CHANGE = 'PolicyChange';
    var SUBMISSION = 'Submission';
    var RENEWAL = 'Renewal';

    ctrl.init = function () {
        var model = submissionViewModel();

        if (!model) {
            $state.go(RootStates.home);
            //  console.log('test');
            // throw new Error('Model not found! Redirecting to home page.');
        }

        var jobType = model.value.baseData.jobType || SUBMISSION;

        if (jobType === POLICY_CHANGE) {
            $scope.isPolicyChange = true;
        } else if (jobType === RENEWAL) {
            $scope.isRenewal = true;
        } else if (jobType === SUBMISSION) {
            $scope.isQuote = true;
        }

        var jobID = model.jobID ? model.jobID.value : model.quoteID.value;
        //CoveragesUtil.getDependentCoveragesForLOB(CoverageService, jobID);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'state_plugin_config', '$state', 'CoveragesUtil', 'CoverageService', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/baseTransaction/BaseTransactionWizardCtrl.js
// module id = 1006
// module chunks = 0